// extracted by mini-css-extract-plugin
export var pinPrimary = "Pin-module--pin--primary--3ZIYp";
export var pinType2 = "Pin-module--pin--type-2--1LnKY";
export var pinType3 = "Pin-module--pin--type-3--tZ-hP";